import { connect } from "react-redux";
import AudienceBuilder from "../../components/AudienceBuilder/index";
import isEmpty from "lodash/isEmpty";
import {
  loadAttributes,
  selectSegment,
  setSegmentName,
  getAllStates,
  selectCity,
  selectCounty,
  selectDMA,
  getCities,
  selectState,
  setPlotValues,
  clearAllSelectedState,
  clearAllSelectedCity,
  clearAllZipCode,
  clearAllCounty,
  clearAllDMA,
  clearZipCode,
  addZipCode,
  selectMake,
  selectModel,
  verifySegmentNameAndContinue,
  verifySegmentName,
  getAllStateCities,
  addMakeActive,
  addRegionActive,
  getAudienceCount,
  clearAudienceCount,
  getPlottedAudienceCount,
  getZipcodeAudienceCount,
  getZipcodeDetailCounts,
  clearZipcodeCounts,
  getCategoryAudienceCounts,
  clearCategoryAudienceCounts,
  checkSegmentLimitExceeded,
  verifyAndContinue,
  selectCultureLocale,
  selectCultureRegion,
  setTargetHouseholdOnly,
  getCounties,
  getDMAs,
  saveSegment,
  selectAllState,
  clearAllAutoSelected,
  clearAllRegionSelected,
} from "../../actions/SegmentCreation";
import {
  fetchSegmentSummary,
  getSegmentCounts,
} from "../../actions/SegmentDetail";
import { getSegmentWithRules } from "../../actions/SegmentList";
import { sendAssistRequest } from "../../actions/Insights";
import { selectClient } from "../../actions/App";

import tail from "lodash/tail";
import uniqBy from "lodash/uniqBy";
import isUndefined from "lodash/isUndefined";

const mapStateToProps = (state) => {
  const {
    categories,
    value_typehead,
    selected_segments,
    segment_name,
    allstates,
    userSelectedInfo,
    selected_city,
    selected_county,
    selected_dma,
    isNameDuplicated,
    selected_state,
    allcities,
    plotted_values,
    zipcode,
    catAudienceCounts,
    selected_make,
    selected_model,
    selected_culture_region,
    selected_culture_locale,
    copy_segment_name,
    segment_id,
    rules_id,
    all_state_cities,
    ifLoading,
    make_active_arr,
    region_active_arr,
    audience_total_count,
    zipcode_audience_count,
    save_segment_success,
    save_segment_error_errorNo,
    send_assist_request_error,
    request_assist_successful,
    save_segment_error_message,
    check_client_limit,
    targetHouseholdsOnly,
    counties,
    dmas,
  } = state.segmentCreation;
  const { active_segment_attributes } = state.segmentList;
  const { selected_client, userId, roleId, clients } = state.app;
  const demographic = categories ? tail(categories) : undefined;
  const geographic = categories ? categories[0] : undefined;
  const selectedClient = isEmpty(clients)
    ? []
    : clients.find(function (item) {
        return parseInt(item.id, 10) === parseInt(selected_client, 10);
      });
  return {
    clients,
    client_info: state.app.client_info,
    geoAttributes: geographic,
    demoAttributes: uniqBy(demographic, (d) => {
      return d.id;
    }),
    selected_segments,
    userId,
    roleId,
    selected_client,
    selected_client_name: selectedClient ? selectedClient.name : "",
    allstates,
    userSelectedInfo,
    selected_city,
    selected_state,
    selected_county,
    selected_dma,
    segment_name,
    value_typehead,
    allcities,
    plotted_values,
    zipcode,
    catAudienceCounts,
    selected_make,
    selected_model,
    selected_culture_region,
    selected_culture_locale,
    isNameDuplicated,
    copy_segment_name,
    segment_id,
    rules_id,
    all_state_cities,
    ifLoading,
    make_active_arr,
    region_active_arr,
    audience_total_count,
    zipcode_audience_count,
    active_segment_attributes,
    save_segment_success,
    save_segment_error_errorNo,
    send_assist_request_error,
    request_assist_successful,
    save_segment_error_message,
    check_client_limit,
    segment_active_creation: state.segmentCreation,
    counties,
    dmas,
    targetHouseholdsOnly:
      isUndefined(targetHouseholdsOnly) && active_segment_attributes
        ? active_segment_attributes.targetHouseholdsOnly
        : targetHouseholdsOnly,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    selectClient: (id) => {
      dispatch(selectClient(id));
    },
    sendAssistRequest: (data) => {
      dispatch(sendAssistRequest(data));
    },
    loadAttributes: (cid) => {
      dispatch(loadAttributes(cid));
    },
    selectSegment: (val) => {
      dispatch(selectSegment(val));
    },
    getAllStates: () => {
      dispatch(getAllStates());
    },
    getCities: (cityId) => {
      dispatch(getCities(cityId));
    },
    clearAllSelectedState: () => {
      dispatch(clearAllSelectedState());
    },
    clearAllSelectedCity: () => {
      dispatch(clearAllSelectedCity());
    },
    clearAllZipCode: () => {
      dispatch(clearAllZipCode());
    },
    clearAllCounty: () => {
      dispatch(clearAllCounty());
    },
    clearAllDMA: () => {
      dispatch(clearAllDMA());
    },
    clearZipCode: (val) => {
      dispatch(clearZipCode(val));
    },
    addZipCode: (value) => {
      dispatch(addZipCode(value));
    },
    selectCity: (cityObj, stateLabel, flag) =>
      dispatch(selectCity(cityObj, stateLabel, flag)),
    selectState: (id, flag) => dispatch(selectState(id, flag)),
    selectMake: (makeObj, flag) => dispatch(selectMake(makeObj, flag)),
    selectModel: (modelObj, flag) => dispatch(selectModel(modelObj, flag)),
    selectCultureRegion: (obj, flag) =>
      dispatch(selectCultureRegion(obj, flag)),
    selectCultureLocale: (obj, flag) =>
      dispatch(selectCultureLocale(obj, flag)),
    setSegmentName: (val) => {
      dispatch(setSegmentName(val));
    },
    setPlotValues: (val) => {
      dispatch(setPlotValues(val));
    },
    verifySegmentNameAndContinue: (clientId, name, id) => {
      dispatch(verifySegmentNameAndContinue(clientId, name, id));
    },
    verifySegmentName: (clientId, name, id) => {
      dispatch(
        verifySegmentNameAndContinue(
          clientId,
          name,
          id,
          "/segments/builder?step=confirm",
        ),
      );
    },
    verifyAndContinue: (clientId, name) => {
      dispatch(verifyAndContinue(clientId, name));
    },
    getAllStateCities: () => {
      dispatch(getAllStateCities());
    },
    addMakeActive: (value) => {
      dispatch(addMakeActive(value));
    },
    addRegionActive: (value) => {
      dispatch(addRegionActive(value));
    },
    getAudienceCount: (data, sid) => {
      dispatch(getAudienceCount(data, sid));
    },
    getPlottedAudienceCount: (data, sid) => {
      dispatch(getPlottedAudienceCount(data, sid));
    },
    clearAudienceCount: () => {
      dispatch(clearAudienceCount());
    },
    getZipcodeAudienceCount: (data, sid) => {
      dispatch(getZipcodeAudienceCount(data, sid));
      dispatch(getZipcodeDetailCounts(data, sid));
    },
    clearZipcodeCounts: () => {
      dispatch(clearZipcodeCounts());
    },
    getCategoryAudienceCount: (rules, sid) => {
      dispatch(getCategoryAudienceCounts(rules, sid));
    },
    clearCategoryAudienceCounts: (categoryId) => {
      dispatch(clearCategoryAudienceCounts(categoryId));
    },
    checkSegmentLimitExceeded: (clientId) => {
      dispatch(checkSegmentLimitExceeded(clientId));
    },
    setTargetHouseholdOnly: (checked) => {
      dispatch(setTargetHouseholdOnly(checked));
    },
    loadCounties: () => {
      dispatch(getCounties());
    },
    loadDMAs: () => {
      dispatch(getDMAs());
    },
    selectCounty: (countyObj, stateLabel, flag) =>
      dispatch(selectCounty(countyObj, stateLabel, flag)),
    selectDMA: (dmaObj, stateLabel, flag) => {
      dispatch(selectDMA(dmaObj, stateLabel, flag));
    },
    saveSegment: (data) => {
      dispatch(saveSegment(data));
    },
    selectAllState: (val, flag) => {
      dispatch(selectAllState(val, flag));
    },
    getSegmentDetail: (id, cid) => {
      dispatch(getSegmentWithRules(id, cid));
      //dispatch(getSegmentCounts(id));
    },
    clearAllAutoSelected: () => {
      dispatch(clearAllAutoSelected());
    },
    clearAllRegionSelected: () => {
      dispatch(clearAllRegionSelected());
    },
  };
};

const AudienceBuilderContainer = connect(
  mapStateToProps,
  mapDispatchToProps,
)(AudienceBuilder);
export default AudienceBuilderContainer;



// WEBPACK FOOTER //
// ./src/containers/Segment/AudienceBuilderContainer.js